import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  GET_CATALOGUE,
  GET_CATALOGUE_BY_METADATA_ID,
  POST_CONNECT_CATALOGUE_TO_METADATA,
  DELETE_DISCONNECT_CATALOGUE_FROM_METADATA,
  GET_PRODUCTS,
  POST_PRODUCTS,
} from '../../../api/wca/wca.product.services';

// ✅ Get Catalogue
export const getCatalogue = createAsyncThunk(
  'product/getCatalogue',
  async (catalogID, { rejectWithValue }) => {
    try {
      const response = await GET_CATALOGUE(catalogID);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// ✅ Get Catalogue by Metadata ID
export const getCatalogueByMetadataId = createAsyncThunk(
  'product/getCatalogueByMetadataId',
  async (metadataid, { rejectWithValue }) => {
    try {
      const response = await GET_CATALOGUE_BY_METADATA_ID(metadataid);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// ✅ Connect Catalogue
export const connectCatalogue = createAsyncThunk(
  'product/connectCatalogue',
  async ({ metadataid, data }, { rejectWithValue }) => {
    try {
      const response = await POST_CONNECT_CATALOGUE_TO_METADATA(metadataid, data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// ✅ Disconnect Catalogue
export const disconnectCatalogue = createAsyncThunk(
  'product/disconnectCatalogue',
  async ({ metadataid, data }, { rejectWithValue }) => {
    try {
      const response = await DELETE_DISCONNECT_CATALOGUE_FROM_METADATA(metadataid, data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// ✅ Get Products
export const getProducts = createAsyncThunk(
  'product/getProducts',
  async ({ metadataId, cursor, search }, { rejectWithValue }) => {
    try {
      const response = await GET_PRODUCTS(metadataId, cursor, search);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// ✅ Create Product
export const createProduct = createAsyncThunk(
  'product/createProduct',
  async ({ metadataid, data }, { rejectWithValue }) => {
    try {
      const response = await POST_PRODUCTS(metadataid, data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
